import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';

import CustomDropdown from '@components/CustomDropdown';
import LoaderComponent from '@components/LoaderComponent';
import { toastError, toastSuccess } from '@components/Toast';

import { getAllCountries } from '@store/reducers';
import { fetchAllCountry } from '@store/supplier/action';

import ApiClient from '@lib/apiClient';

const AddBuyerAddress = ({
	onAddBuyerAddress,
	details,
	geDetailsInfo,
	editedLocationInfo,
	isEditLocation,
	onCloseLocation
}) => {
	const [show, setShow] = useState(true);
	const [isSubmitLoading, setIsSubmitLoading] = useState(false);

	const [addressInfo, setaAddressInfo] = useState({
		id: editedLocationInfo?.id ? editedLocationInfo.id : '',
		title: editedLocationInfo?.title ? editedLocationInfo.title : '',
		address: editedLocationInfo?.address ? editedLocationInfo.address : '',
		address2: editedLocationInfo?.address2 ? editedLocationInfo.address2 : '',
		city: editedLocationInfo?.city ? editedLocationInfo.city : '',
		state: editedLocationInfo?.state ? editedLocationInfo.state : '',
		zip: editedLocationInfo?.zip ? editedLocationInfo.zip : '',
		countryId: editedLocationInfo?.countryResponse?.id ? editedLocationInfo?.countryResponse?.id : '',
		landMark: editedLocationInfo?.landMark ? editedLocationInfo.landMark : ''
	});
	const [errors, setErrors] = useState({});
	let countries = useSelector(getAllCountries);
	countries = countries.map((item) => ({ ...item, value: item.name }));
	const dispatch = useDispatch();

	const handleClose = (isModified) => {
		setShow(false);
		onAddBuyerAddress(isModified);
	};

	const onCloseLocationEdit = (isModified) => {
		setShow(false);
		onCloseLocation(isModified);
	};
	const onCloseModal = () => {
		if (isEditLocation) {
			onCloseLocationEdit();
		} else {
			handleClose();
		}
	};

	const onChangeAddressInfo = (e) => {
		let { id, value } = e.target;
		setaAddressInfo({ ...addressInfo, [id]: value });
	};

	const onCountryClick = (data) => {
		setaAddressInfo({ ...addressInfo, countryId: data.id, countryName: data.name });
	};

	const isValidForm = (body) => {
		if (body.title === '' || !body.title) {
			setErrors({ ...errors, titleError: 'Title is required' });
			return false;
		}
		if (body.address === '' || !body.address) {
			setErrors({ ...errors, addressError: 'Address is required' });
			return false;
		}
		if (body.city === '' || !body.city) {
			setErrors({ ...errors, cityError: 'City is required' });
			return false;
		}
		if (body.countryId === '' || !body.countryId) {
			setErrors({ ...errors, countryError: 'Country is required.' });
			return false;
		}
		return true;
	};

	const onAddLocation = async () => {
		setIsSubmitLoading(true);
		const isValid = isValidForm(addressInfo);
		if (!isValid) {
			setIsSubmitLoading(false);
			return;
		}
		await ApiClient.POST('addBrandLocation', { ...addressInfo }, details.brandId)
			.then(({ data }) => {
				setIsSubmitLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					if (geDetailsInfo) {
						geDetailsInfo(details.id);
					}
					handleClose(true);
				}
			})
			.catch(({ response }) => {
				setIsSubmitLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
				handleClose();
			});
	};

	const onUpdateLocation = async () => {
		setIsSubmitLoading(true);
		const isValid = isValidForm(addressInfo);
		if (!isValid) {
			setIsSubmitLoading(false);
			return;
		}
		await ApiClient.PUT('updateLocation', addressInfo, addressInfo.id)
			.then(({ data }) => {
				setIsSubmitLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					onCloseLocationEdit(true);
				}
			})
			.catch(({ response }) => {
				setIsSubmitLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
				onCloseLocationEdit();
			});
	};

	const onSubmit = () => {
		if (isEditLocation) {
			onUpdateLocation();
		} else {
			onAddLocation();
		}
	};

	useEffect(() => {
		dispatch(fetchAllCountry());
	}, []);

	return (
		<LoaderComponent loading={isSubmitLoading}>
			<Modal show={show} onHide={onCloseModal} backdrop="static" centered>
				<div className="common-popup shadow-24dp">
					<Modal.Header closeButton>
						<h3 className="semibold-16 mb-0">Add address</h3>
					</Modal.Header>
					<Modal.Body>
						<div className="common-popup-body">
							<div className="container px-0">
								<div className="row">
									<div className="col-md-12">
										<div className="form-group ">
											<label htmlFor="title">Title*</label>
											<input
												type="text"
												autoComplete="off"
												id="title"
												value={addressInfo.title}
												onChange={onChangeAddressInfo}
											/>
											{errors.titleError && (
												<p className="error">{errors.titleError}</p>
											)}
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group ">
											<label htmlFor="address">Address line 1*</label>
											<input
												type="text"
												autoComplete="off"
												id="address"
												value={addressInfo.address}
												onChange={onChangeAddressInfo}
											/>
											{errors.addressError && (
												<p className="error">{errors.addressError}</p>
											)}
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group ">
											<label htmlFor="address2">Address line 2</label>
											<input
												type="text"
												autoComplete="off"
												id="address2"
												value={addressInfo.address2}
												onChange={onChangeAddressInfo}
											/>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-group ">
											<label htmlFor="city">City*</label>
											<input
												type="text"
												autoComplete="off"
												id="city"
												value={addressInfo.city}
												onChange={onChangeAddressInfo}
											/>
											{errors.cityError && <p className="error">{errors.cityError}</p>}
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-group ">
											<label htmlFor="zip">Zip</label>
											<input
												type="text"
												autoComplete="off"
												id="zip"
												value={addressInfo.zip}
												onChange={onChangeAddressInfo}
											/>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-group">
											<label htmlFor="state">Country*</label>
											<CustomDropdown
												type="addItem"
												title={''}
												isShowLabel={false}
												onItemClick={(value) => onCountryClick(value)}
												items={countries}
												selectedItem={addressInfo?.countryName || ''}
											/>
											{errors.countryError && (
												<p className="error">{errors.countryError}</p>
											)}
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-group">
											<label htmlFor="state">State</label>
											<input
												type="text"
												autoComplete="off"
												id="state"
												value={addressInfo.state}
												onChange={onChangeAddressInfo}
											/>
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group mb-0">
											<label htmlFor="land-mark">Land mark</label>
											<input
												type="text"
												autoComplete="off"
												id="landMark"
												value={addressInfo.landMark}
												onChange={onChangeAddressInfo}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<div className="footer-buttons text-right">
							<button className="button outline size32" onClick={onCloseModal}>
								Cancel
							</button>
							<button
								className="button size32 ml-2"
								disabled={isSubmitLoading}
								onClick={onSubmit}
							>
								Submit
							</button>
						</div>
					</Modal.Footer>
				</div>
			</Modal>
		</LoaderComponent>
	);
};

export default AddBuyerAddress;
